import React, {useEffect, useRef} from 'react';
import {Box, Link, Grid, Card, CardContent, Button, IconButton, Typography} from '@mui/material';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TransactionTable from '../../components/Dashboard/TransactionsTable';
import BuyTransactionTable from '../../components/Buy/TransactionsTable';
import { useUserContext } from '../../hooks/auth/UserProvider';
import { GREEN_MAIN } from '../../theme/colors';


const TransactionsAuth:React.FC<{type:number}> = ({type}) => {
    const auth = useAuth();
    const navigate = useNavigate();
    const {t} = useTranslation();
    const [loading, setLoading] = React.useState(true);
    const {checkIsAuth}= useUserContext();

    useEffect(()=>{
        if (!auth.isLoading) {
            if (!auth.isAuthenticated) {
                navigate('/');
            } else {
                setLoading(false);
            }
        }
        checkIsAuth().finally();
    },[auth.isAuthenticated, auth.isLoading, navigate])

    return(
        <>
            <Box sx={{
                width:'100%', 
                display:'flex', 
                justifyContent:'center',
                flexDirection: 'column',
                color: GREEN_MAIN,
                fontFamily:'poppins'
            }}>
                {/* Main title */}
                <Typography
                    variant="h3"
                    component="h1"
                    gutterBottom
                    sx={{
                        mb: 10,
                        mt:0,
                        fontWeight: "bold",
                    }}
                >
                    {
                    auth.isAuthenticated && 
                        type === 0 ? t("Archivio Transazioni") : 
                        type === 1 ? t("Archivio Acquisti") : null
                    }
                </Typography>
                {
                    auth.isAuthenticated && 
                    type === 0 ? <TransactionTable /> : 
                    type === 1 ? <BuyTransactionTable /> : null
                }
            </Box>
        </>
    )
}

export default TransactionsAuth;